<template>
    <div class="form-group row">
        <div class="col-md-10 offset-md-1">
            <div class="custom-control custom-checkbox flex items-center">
                <input
                    v-model="checked"
                    :id="checkboxId"
                    class="custom-control-input"
                    :disabled="!isAdmin || disabled"
                    :name="checkboxId"
                    type="checkbox"
                />
                <label
                    class="custom-control-label disable-text-select inline"
                    :for="checkboxId"
                >
                    <slot name="beforeInput"></slot>
                    <slot name="afterInput"></slot>
                    <slot name="tooltip"></slot>
                </label>
                <input
                    v-model="inputValue"
                    ref="inputEl"
                    class="reminder-text-input ml-1 w-12"
                    :class="{ 'text-transparent': inputDisabled }"
                    :disabled="inputDisabled"
                    :max="inputMax"
                    :min="inputMin"
                    :name="inputName"
                    type="number"
                />
            </div>
        </div>
    </div>
</template>

<script lang="ts">
export const OPTION_WITH_NUMBER_INPUT_DEFAULT_MIN = 2;
export const OPTION_WITH_NUMBER_INPUT_DEFAULT_MAX = 30;
</script>

<script setup lang="ts">
import { computed, useTemplateRef, watch } from 'vue';

export interface OptionWithNumberInputProps {
    checkboxId?: string;
    disabled?: boolean;
    inputName: string;
    isAdmin: boolean;
    inputMin?: number;
    inputMax?: number;
}

export interface OptionWithNumberInputModels {
    checked: boolean;
    inputValue: number;
}

const props = withDefaults(defineProps<OptionWithNumberInputProps>(), {
    inputMin: OPTION_WITH_NUMBER_INPUT_DEFAULT_MIN,
    inputMax: OPTION_WITH_NUMBER_INPUT_DEFAULT_MAX,
});

const checked = defineModel<OptionWithNumberInputModels['checked']>('checked', { required: true });
const inputValue = defineModel<OptionWithNumberInputModels['inputValue']>('inputValue', { required: true });

const inputElement = useTemplateRef('inputEl');

const validationMessage = `Please enter a value between ${props.inputMin} and ${props.inputMax}.`;
const inputDisabled = computed(() => !props.isAdmin || props.disabled || !checked.value);

watch(inputValue, value => {
    if (!inputElement.value) return;
    const inRange = value >= props.inputMin && value <= props.inputMax;
    inputElement.value.setCustomValidity(inRange ? '' : validationMessage);
});
</script>
